import _ from 'lodash';
import QueryString from 'qs';

export function omitFromQs(
  qsParamName,
  search = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true
  })
) {
  const newSearchString = `${QueryString.stringify(
    _.omit(search, [qsParamName])
  )}`;
  window.history.replaceState(
    {},
    document.title,
    newSearchString
      ? `${window.location.pathname}?${newSearchString}`
      : window.location.pathname
  );
}
